// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { mergeStyles } from '@fluentui/react';
import { CallEnd20Filled, Checkmark20Regular, CheckmarkCircle16Regular, Circle16Regular, Delete20Regular, Dismiss20Regular, Edit20Regular, ErrorCircle16Regular, EyeShow16Regular, MicOff16Filled, MicOff16Regular, MicOff20Filled, MicOn20Filled, MicOn20Regular, MoreHorizontal20Filled, MoreHorizontal20Regular, People20Filled, Settings20Filled, Send20Filled, Send20Regular, ShareScreenStart20Filled, ShareScreenStop20Filled, Speaker220Regular, Video20Filled, Video20Regular, VideoOff20Filled, ChevronLeft20Regular, ChevronRight20Regular, WifiWarning20Filled, SpeakerMute16Filled, MicProhibited16Filled, VideoProhibited16Filled } from '@fluentui/react-icons';
import React from 'react';
const WifiWarning16Filled = () => // All ErrorBar icons are 16px x 16px (when 1rem = 16 px).
 
// There is no 16px version of this icon in the fluent icon package, so scale the larger
// one down to required size.
React.createElement("div", { className: mergeStyles({
        transform: 'scale(0.8)'
    }) },
    React.createElement(WifiWarning20Filled, null));
/**
 * The default set of icons that are available to use in the UI components.
 *
 * @remark Icons used only in the composites are available in {@link DEFAULT_COMPOSITE_ICONS}.
 *
 * @public
 */
export const DEFAULT_COMPONENT_ICONS = {
    ControlButtonCameraOff: React.createElement(VideoOff20Filled, null),
    ControlButtonCameraOn: React.createElement(Video20Filled, null),
    ControlButtonEndCall: React.createElement(CallEnd20Filled, null),
    ControlButtonMicOff: React.createElement(MicOff20Filled, null),
    ControlButtonMicOn: React.createElement(MicOn20Filled, null),
    ControlButtonOptions: React.createElement(Settings20Filled, null),
    ControlButtonParticipants: React.createElement(People20Filled, null),
    ControlButtonScreenShareStart: React.createElement(ShareScreenStart20Filled, null),
    ControlButtonScreenShareStop: React.createElement(ShareScreenStop20Filled, null),
    EditBoxCancel: React.createElement(Dismiss20Regular, null),
    EditBoxSubmit: React.createElement(Checkmark20Regular, null),
    ErrorBarCallCameraAccessDenied: React.createElement(VideoProhibited16Filled, null),
    ErrorBarCallCameraAlreadyInUse: React.createElement(VideoProhibited16Filled, null),
    ErrorBarCallLocalVideoFreeze: React.createElement(WifiWarning16Filled, null),
    ErrorBarCallMacOsCameraAccessDenied: React.createElement(VideoProhibited16Filled, null),
    ErrorBarCallMacOsMicrophoneAccessDenied: React.createElement(MicProhibited16Filled, null),
    ErrorBarCallMicrophoneAccessDenied: React.createElement(MicProhibited16Filled, null),
    ErrorBarCallMicrophoneMutedBySystem: React.createElement(MicOff16Filled, null),
    ErrorBarCallNetworkQualityLow: React.createElement(WifiWarning16Filled, null),
    ErrorBarCallNoMicrophoneFound: React.createElement(MicProhibited16Filled, null),
    ErrorBarCallNoSpeakerFound: React.createElement(SpeakerMute16Filled, null),
    HorizontalGalleryLeftButton: React.createElement(ChevronLeft20Regular, null),
    HorizontalGalleryRightButton: React.createElement(ChevronRight20Regular, null),
    MessageDelivered: React.createElement(CheckmarkCircle16Regular, null),
    MessageEdit: React.createElement(Edit20Regular, null),
    MessageFailed: React.createElement(ErrorCircle16Regular, null),
    MessageRemove: React.createElement(Delete20Regular, null),
    MessageSeen: React.createElement(EyeShow16Regular, null),
    MessageSending: React.createElement(Circle16Regular, null),
    OptionsCamera: React.createElement(Video20Regular, null),
    OptionsMic: React.createElement(MicOn20Regular, null),
    OptionsSpeaker: React.createElement(Speaker220Regular, null),
    ParticipantItemMicOff: React.createElement(MicOff16Regular, null),
    ParticipantItemOptions: React.createElement(MoreHorizontal20Regular, null),
    ParticipantItemOptionsHovered: React.createElement(MoreHorizontal20Filled, null),
    ParticipantItemScreenShareStart: React.createElement(ShareScreenStart20Filled, null),
    SendBoxSend: React.createElement(Send20Regular, null),
    SendBoxSendHovered: React.createElement(Send20Filled, null),
    VideoTileMicOff: React.createElement(MicOff16Filled, null)
};
//# sourceMappingURL=icons.js.map